import { render, staticRenderFns } from "./RealtimeTrace.vue?vue&type=template&id=56d5b0f8&"
import script from "./RealtimeTrace.vue?vue&type=script&lang=js&"
export * from "./RealtimeTrace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports